<template>
  <div class="uploader d-inline-block">
    <slot name="button">
      <button
        type="button"
        :class="`btn btn-${variant}`"
      >
        <i :class="`fa fa-fw fa-${icon} mr-1`" />
        {{ label }}
      </button>
    </slot>
    <b-progress
      v-if="uploading"
      :value="progress"
      :max="100"
      class="mt-1"
      style="height:8px;"
    ></b-progress>
  </div>
</template>

<style>

</style>

<script>
import $ from 'jquery'
import plupload from 'plupload'
import api from '@/api'
import urls from '@/api/urls'
import alertify from 'alertify.js'
import bag from '@/lib/MessageBag'
import { toQueryString } from '@/lib/utils'

export default {
  name: 'Upload',
  props: {
    label: {
      type: String,
      default: 'Upload'
    },
    variant: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: 'upload'
    },
    headers: {
      type: Object,
      default () {
        return {}
      }
    },
    progressBarColor: {
      type: String,
      default: '#111'
    },
    value: {
      type: Object,
      default: null
    },
    url: {
      type: String,
      default: api.defaults.baseURL + '/' + urls.upload.document()
    },
    attachableType: {
      type: String,
      default: null
    },
    attachableId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      uploading: false,
      progress: 0
    }
  },
  computed: {
    uploadHeaders () {
      return api.defaults.headers.common
    }
  },
  mounted () {
    let vm = this
    let $container = $(this.$el)
    let $button = $container.find('button')
    let $label = $button.html()

    let url = vm.url
    if (vm.attachableType && vm.attachableId) {
      let query = toQueryString({
        attachable_type: vm.attachableType,
        attachable_id: vm.attachableId
      })
      url += url.indexOf('?') > -1 ? query : '?' + query
    }

    let uploader = new plupload.Uploader({
      container: $container[0],
      browse_button: $button[0],
      filters: {
        max_file_size: this.maxFileSize
      },
      url,
      headers: this.uploadHeaders,
      init: {
        FilesAdded (up, files) {
          uploader.start()
          vm.uploading = true
          vm.$emit('uploading')
          $button.attr('disable', true)
          $button.html('<span><i class="fa fa-fw fa-circle-o-notch fa-spin mr-1" /> Uploading...</span>')
        },
        UploadProgress (up, file) {
          vm.progress = file.percent
        },
        FileUploaded (up, file, object) {
          setTimeout(() => {
            $button.attr('disable', false)
            $button.html($label)
            vm.uploading = false
            vm.progress = 0
            let response = JSON.parse(object.response)
            vm.$emit('uploaded', response)
            vm.$emit('input', response)
          }, 2000)
        },
        Error (uploader, error) {
          vm.uploading = false
          $button.attr('disable', false)
          $button.html($label)
          if (error.code === -600) {
            alertify.alert("We're sorry, but the file you're trying to upload is too large. Please try a smaller file.")
          }
          if (error.status === 422) {
            alertify.alert(bag(error.response).first())
          }
          vm.$emit('error', error, uploader)
        }
      }
    })

    uploader.init()
  }
}
</script>
